const BootSplash = {
  hide: async () => {},
  isVisible: async () => false,
  useHideAnimation: () => ({ container: {}, logo: {}, brand: {} }),
};

module.exports = BootSplash;
module.exports.default = BootSplash;
